module.exports = __webpack_public_path__ + "joe-gardner-2.jpg?76ff47ae5c64ccda5af18326bb272058";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/joe-gardner-2.jpg
// module id = 240
// module chunks = 0